module.exports = __webpack_public_path__ + "static/img/EC_Centered_Logo-2x.81b3513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EC_Centered_Logo-2x.png
// module id = xFBw
// module chunks = 4